/**
 * Подтверждение email по ссылке из письма (?token=...).
 * Повторную отправку письма может запросить только вошедший пользователь —
 * эндпоинт resend-verification требует авторизации.
 */
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { LayoutContext } from '../context';
import { APIAuthVerifyEmail, APIAuthResendVerification } from '../api_auth';
import {
    AuthBackground, Logo, PrimaryButton, TextLink, StatusScreen, Spinner,
    IconCheckCircle, IconClock,
} from '../components/Auth/ui';

export default function VerifyEmailPage() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const token = params.get('token') || '';
    const { token: authToken } = useContext(LayoutContext);

    const [state, setState] = useState('loading');     // loading | success | error
    const [message, setMessage] = useState(null);
    const [resent, setResent] = useState(false);

    useEffect(() => {
        if (!token) {
            setState('error');
            setMessage('В ссылке нет кода подтверждения');
            return;
        }
        (async () => {
            try {
                await APIAuthVerifyEmail(token);
                setState('success');
            } catch (e) {
                setState('error');
                setMessage(e?.response?.data?.error || 'Не удалось подтвердить email');
            }
        })();
    }, [token]);

    const resend = async () => {
        try {
            await APIAuthResendVerification(authToken);
            setResent(true);
        } catch (_e) {
            setMessage('Не удалось отправить письмо. Попробуйте позже');
        }
    };

    if (state === 'loading') {
        return (
            <AuthBackground>
                <div className="lv-screen lv-status">
                    <div className="lv-status__card">
                        <Logo size="lg" />
                        <h1 className="lv-status__title">Подтверждаем email…</h1>
                        <div className="lv-status__actions" style={{ alignItems: 'center' }}>
                            <Spinner size="lg" />
                        </div>
                    </div>
                </div>
            </AuthBackground>
        );
    }

    if (state === 'success') {
        return (
            <StatusScreen icon={<IconCheckCircle />} title="Email подтверждён"
                          text="Спасибо! Теперь все письма от Lovirds будут доходить до вас.">
                <PrimaryButton onClick={() => navigate(authToken ? '/' : '/login')}>
                    {authToken ? 'Вернуться в приложение' : 'Войти'}
                </PrimaryButton>
            </StatusScreen>
        );
    }

    return (
        <StatusScreen icon={<IconClock />} title="Ссылка не сработала"
                      text={resent ? 'Отправили новое письмо — проверьте почту.' : message}>
            {authToken && !resent ? (
                <PrimaryButton onClick={resend}>Отправить письмо ещё раз</PrimaryButton>
            ) : null}
            <PrimaryButton variant="ghost" onClick={() => navigate(authToken ? '/' : '/login')}>
                {authToken ? 'Вернуться в приложение' : 'Войти'}
            </PrimaryButton>
            {!authToken ? <TextLink onClick={() => navigate('/')}>Создать анкету</TextLink> : null}
        </StatusScreen>
    );
}
